import { SelectHTMLAttributes, forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
    label?: string;
    error?: string;
    hint?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
    ({ label, error, hint, className = '', id, children, ...props }, ref) => {
        const selectId = id || label?.toLowerCase().replace(/\s+/g, '-');
        return (
            <div className="w-full">
                {label && (
                    <label htmlFor={selectId} className="block text-sm font-semibold text-slate-700 mb-1.5">
                        {label}
                    </label>
                )}
                <div className="relative">
                    <select
                        ref={ref}
                        id={selectId}
                        className={`w-full appearance-none px-4 py-2.5 pr-10 rounded-lg border transition-all outline-none
                            ${error
                                ? 'border-red-400 bg-red-50 focus:ring-2 focus:ring-red-300 focus:border-red-400'
                                : 'border-slate-200 bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                            }
                            disabled:bg-slate-100 disabled:text-slate-400 disabled:cursor-not-allowed
                            text-slate-900 text-sm cursor-pointer
                            ${className}`}
                        {...props}
                    >
                        {children}
                    </select>
                    <ChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                </div>
                {hint && !error && <p className="mt-1.5 text-xs text-slate-500">{hint}</p>}
                {error && <p className="mt-1.5 text-xs text-red-600">{error}</p>}
            </div>
        );
    }
);

Select.displayName = 'Select';
